import { type PictogramIconProps } from './types';

export const Safety = ({ color }: PictogramIconProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="28.708"
        height="28.708"
        x="-1.294"
        y="17.834"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.2"
        rx="7.4"
        transform="rotate(-45 -1.294 17.834)"
      />
      <path
        fill={color ?? 'currentColor'}
        d="M18.859 27.496a1.893 1.893 0 0 0 1.895-1.891 1.89 1.89 0 0 0-1.895-1.891 1.893 1.893 0 0 0-1.895 1.89c0 1.046.848 1.892 1.895 1.892m-1.718-16.993a.56.56 0 0 0-.567.626l.996 9.658a.49.49 0 0 0 .476.428h1.423a.71.71 0 0 0 .692-.626l.974-9.464a.557.557 0 0 0-.567-.626h-3.431z"
      />
    </svg>
  );
};
